import { ConfigService } from '../../config/config.service';

export class QuickstartGuideService {
    public async quickStartGuideLinkIncludingPage(heading: string): Promise<string> {
        const link = await this.getQuickstartGuideLink();
        return link + heading;
    }

    public async getQuickstartGuideLink(): Promise<string> {
        return ConfigService.imsQuickStartGuideLink;
    }
}
